import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Col, Container, Row} from "react-bootstrap";
import Slick from "react-slick";
import reactHtmlParser from "react-html-parser";
import {Img} from "../Img";
import {darkBlue, hover, white} from "../../styles/globalStyleVars";
import {useLocation} from "react-router-dom";

const SliderCount = ({title, padding, data,id}) => {
    const [offset, setOffset] = useState(90)
    const [activeSlide, setactiveSlide] = useState(0)
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();
    const [total, settotal] = useState();
    const slider1 = useRef(null);
    const slider2 = useRef(null);

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);

        // settotal(slider2.current.props.children.length)
    }, []);

    useEffect(() => {
        setOffset(document.querySelector(' .container').offsetLeft)
        settotal(slider2?.current?.props?.children?.length)

    }, [])


    const swiperRefTwo = useRef(null);
    const location = useLocation();



    // handle slider progress
    const handleProgress = (swiper) => {

        let interleaveOffset = 0.5;
        for (let i = 0; i < swiper.slides.length; i++) {
            let slideProgress = swiper.slides[i].progress;
            let innerOffset = swiper.width * interleaveOffset;
            let innerTranslate = slideProgress * innerOffset;
            swiper.slides[i].querySelector(".global-image").style.transform =
                "translate3d(" + innerTranslate + "px, 0, 0)";
        }

    };

    // hand touch move not required this slider
    const handleTouchStart = (swiper) => {

        for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = "";
        }
    };


    // handle image transition on change
    const handleSetTransition = (swiper, speed) => {
        for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = `${speed}ms`;
            swiper.slides[i]
                .querySelector(".global-image")
                .style.transition = `${speed}ms`;

        }
    };
    const swiperRef = useRef(null);

    useEffect(() => {
        const swiper = slider1.current;

        const autoplayDelay = 5000; // Delay in milliseconds before autoplaying

        const autoplayTimeout = setTimeout(() => {
            if (swiper && swiper.autoplay) {
                swiper.autoplay.start();
            }
        }, autoplayDelay);

        return () => {
            clearTimeout(autoplayTimeout);
        };
    }, []);

    return (

        <StyledBox className={`SliderCount  pb-200`} id={`${id ? id : ''}`} >

            <Container fluid className={'p-0'}>
                <Row>
                    <Col md={6} className={'p-0'}>
                        <div className="slider_wrapper_left">
                            <div className="slider_wrapper_left__init">
                                {
                                    data?.list && data?.list?.length>0 ?
                                        <Slick asNavFor={nav2} speed={1200}
                                               arrows={true} ref={slider1}
                                               // onSlideChange={handleSlideChange}
                                               onProgress={handleProgress}
                                               touchStart={handleTouchStart}
                                               onSetTransition={handleSetTransition}
                                               grabCursor={false}
                                               lazy={true}
                                               watchSlidesProgress={true}
                                               mousewheelControl={true}
                                               keyboardControl={true}
                                        >
                                            {
                                                data?.list && data?.list?.length>0 &&
                                                data?.list?.map((element,index)=>{
                                                    return(
                                                        <div  className="single_item" key={index}>
                                                            <div className="image_wrapper">
                                                                <Img src={element?.image}/>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }


                                        </Slick> : ''
                                }

                            </div>
                        </div>
                    </Col>
                    <Col md={6} className={'p-0'}>
                        <div className="slider_wrapper_right">
                            <div className="slider_wrapper_right__init" style={{paddingRight: offset + 30 + 'px'}}>
                                {
                                    data?.list && data?.list?.length>0 ?
                                        <Slick asNavFor={nav1}
                                               ref={slider2}
                                               arrows={false}
                                               dots={false}
                                               speed={1200}
                                               slidesToShow={1}
                                               swipeToSlide={false}
                                               focusOnSelect={false}
                                               afterChange={current => document.querySelector('#current_slider').innerHTML = current + 1}
                                        >
                                            {
                                                data?.list && data?.list?.length>0 &&
                                                data?.list?.map((element,index)=>{
                                                    return(
                                                        <div className="single_item_content" key={index}>
                                                            {element?.title && <h3 className={'split-up'}>{reactHtmlParser(element?.title)}</h3>}
                                                            {
                                                                element?.desc &&
                                                                <p className={'split-up'}>
                                                                    {reactHtmlParser(element?.desc)}
                                                                </p>
                                                            }

                                                        </div>
                                                    )
                                                })
                                            }

                                            {/*<div className="single_item_content">*/}
                                            {/*    <h3>{reactHtmlParser('Integrity')}</h3>*/}
                                            {/*    <p>*/}
                                            {/*        {reactHtmlParser('Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.')}*/}
                                            {/*    </p>*/}
                                            {/*</div>*/}
                                            {/*<div className="single_item_content">*/}
                                            {/*    <h3>{reactHtmlParser('Integrity')}</h3>*/}
                                            {/*    <p>*/}
                                            {/*        {reactHtmlParser('Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.')}*/}
                                            {/*    </p>*/}
                                            {/*</div>*/}
                                        </Slick> : ''

                                }

                                <div className="footer">
                                    <div className="count">
                                        <p><span id={'current_slider'} className="current">1</span>/ <span
                                            className="total">{data?.list?.length}</span></p>
                                    </div>
                                    {/*next prev navigation*/}
                                    <div className="navigation">
                                        <Container>
                                            <Row>
                                                <Col>
                                                    <ul>
                                                        <li onClick={() => slider2?.current?.slickNext()} >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                                                 viewBox="0 0 44 44">
                                                                <g id="Next" transform="translate(16429 -2014)">
                                                                    <g id="Rectangle_492" data-name="Rectangle 492"
                                                                       transform="translate(-16429 2014)" fill="none" stroke="#fff"
                                                                       stroke-width="1" opacity="0.5">
                                                                        <rect width="44" height="44" rx="22" stroke="none"/>
                                                                        <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                                              fill="none"/>
                                                                    </g>
                                                                    <g id="Group_4824" data-name="Group 4824"
                                                                       transform="translate(-17065.5 434.5)">
                                                                        <g id="Group_4823" data-name="Group 4823"
                                                                           transform="translate(11 4)">
                                                                            <line id="Line_9" data-name="Line 9" x2="5" y2="5"
                                                                                  transform="translate(647.5 1592.5)" fill="none"
                                                                                  stroke="#fff"
                                                                                  strokeLinecap="round" stroke-width="1"/>
                                                                            <line id="Line_10" data-name="Line 10" x1="5" y2="5"
                                                                                  transform="translate(647.5 1597.5)" fill="none"
                                                                                  stroke="#fff"
                                                                                  strokeLinecap="round" stroke-width="1"/>
                                                                        </g>
                                                                        <line id="Line_11" data-name="Line 11" x2="10"
                                                                              transform="translate(653.5 1601.5)" fill="none"
                                                                              stroke="#fff"
                                                                              strokeLinecap="round" stroke-width="1"/>
                                                                    </g>
                                                                    <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                                       transform="translate(-16429 2058) rotate(-90)" fill="none"
                                                                       stroke="#fff"
                                                                       stroke-width="1" strokeDasharray="0" opacity="0">
                                                                        <rect width="44" height="44" rx="22" stroke="none"/>
                                                                        <rect x="0.5" y="0.5" width="43" height="43" rx="21.5"
                                                                              fill="none"/>
                                                                    </g>
                                                                </g>
                                                            </svg>

                                                        </li>
                                                        <li onClick={() => slider2?.current?.slickPrev()}>
                                                            <svg id="Prev" xmlns="http://www.w3.org/2000/svg" width="44" height="44"
                                                                 viewBox="0 0 44 44">
                                                                <g id="Rectangle_492" data-name="Rectangle 492" fill="none"
                                                                   stroke="#fff"
                                                                   stroke-width="1" opacity="0.5">
                                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                                                </g>
                                                                <g id="Group_4824" data-name="Group 4824" transform="translate(17 17)">
                                                                    <g id="Group_4823" data-name="Group 4823">
                                                                        <line id="Line_9" data-name="Line 9" x1="5" y2="5" fill="none"
                                                                              stroke="#fff" strokeLinecap="round" stroke-width="1"/>
                                                                        <line id="Line_10" data-name="Line 10" x2="5" y2="5"
                                                                              transform="translate(0 5)" fill="none" stroke="#fff"
                                                                              strokeLinecap="round" stroke-width="1"/>
                                                                    </g>
                                                                    <line id="Line_11" data-name="Line 11" x1="10"
                                                                          transform="translate(0 5)"
                                                                          fill="none" stroke="#fff" strokeLinecap="round"
                                                                          stroke-width="1"/>
                                                                </g>
                                                                <g id="Rectangle_5661" data-name="Rectangle 5661"
                                                                   transform="translate(0 44) rotate(-90)" fill="none" stroke="#fff"
                                                                   stroke-width="1" strokeDasharray="1 140" opacity="0">
                                                                    <rect width="44" height="44" rx="22" stroke="none"/>
                                                                    <rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="none"/>
                                                                </g>
                                                            </svg>


                                                        </li>
                                                    </ul>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                    {/*<ul className="slider_nav">*/}
                                    {/*    <li onClick={() => slider2?.current?.slickPrev()} className={'slider_prev'}>*/}
                                    {/*        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70"*/}
                                    {/*             viewBox="0 0 70 70">*/}
                                    {/*            <circle id="Ellipse_15" data-name="Ellipse 15" cx="35" cy="35" r="35"*/}
                                    {/*                    fill="#e9e4dc"/>*/}
                                    {/*            <circle id="Ellipse_16" data-name="Ellipse 15" cx="35" cy="35" r="0"*/}
                                    {/*                    fill="#191818"/>*/}
                                    {/*            <g id="Group_7" data-name="Group 7" transform="translate(25 30)">*/}
                                    {/*                <line id="Line_4" data-name="Line 4" x1="20"*/}
                                    {/*                      transform="translate(0 5)" fill="none" stroke="#565440"*/}
                                    {/*                      stroke-linecap="round" stroke-width="1"/>*/}
                                    {/*                <line id="Line_5" data-name="Line 5" x1="5" y2="5" fill="none"*/}
                                    {/*                      stroke="#565440" stroke-linecap="round" stroke-width="1"/>*/}
                                    {/*                <line id="Line_6" data-name="Line 6" x1="5" y1="5"*/}
                                    {/*                      transform="translate(0 5)" fill="none" stroke="#565440"*/}
                                    {/*                      stroke-linecap="round" stroke-width="1"/>*/}
                                    {/*            </g>*/}
                                    {/*        </svg>*/}


                                    {/*    </li>*/}
                                    {/*    <li onClick={() => slider2?.current?.slickNext()} className={'slider_next'}>*/}
                                    {/*        <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70"*/}
                                    {/*             viewBox="0 0 70 70">*/}
                                    {/*            <circle id="Ellipse_15" data-name="Ellipse 15" cx="35" cy="35" r="35"*/}
                                    {/*                    fill="#e9e4dc"/>*/}
                                    {/*            <circle id="Ellipse_16" data-name="Ellipse 15" cx="35" cy="35" r="0"*/}
                                    {/*                    fill="#191818"/>*/}

                                    {/*            <g id="Group_7" data-name="Group 7"*/}
                                    {/*               transform="translate(-1023.5 -3171.5)">*/}
                                    {/*                <line id="Line_4" data-name="Line 4" x2="20"*/}
                                    {/*                      transform="translate(1048.5 3206.5)" fill="none"*/}
                                    {/*                      stroke="#565440" stroke-linecap="round" stroke-width="1"/>*/}
                                    {/*                <line id="Line_5" data-name="Line 5" x2="5" y2="5"*/}
                                    {/*                      transform="translate(1063.5 3201.5)" fill="none"*/}
                                    {/*                      stroke="#565440" stroke-linecap="round" stroke-width="1"/>*/}
                                    {/*                <line id="Line_6" data-name="Line 6" y1="5" x2="5"*/}
                                    {/*                      transform="translate(1063.5 3206.5)" fill="none"*/}
                                    {/*                      stroke="#565440" stroke-linecap="round" stroke-width="1"/>*/}
                                    {/*            </g>*/}
                                    {/*        </svg>*/}


                                    {/*    </li>*/}
                                    {/*</ul>*/}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </StyledBox>

    )


};


const StyledBox = styled.section`
  //background: #F7F4F4;
  position: relative;
  //overflow: hidden;
  //
  //&:after {
  //  content: "";
  //  position: absolute;
  //  left: 0;
  //  right: 0;
  //  bottom: 0;
  //  background: #E9E4DC;
  //  height: 50vh;
  //  z-index: 0;
  //
  //  @media (max-width: 992px) {
  //    height: 100px;
  //    z-index: 0;
  //  }
  //}

  .container, .container-fluid {
    position: relative;
    z-index: 2;
  }


  .slider_wrapper_left {
    &__init {
      @media (max-width: 992px) {
        .slick-list {
          margin-bottom: -8px !important;
        }
      }

      .single_item {
        .image_wrapper {
          padding-top: calc(560 / 698 * 100%);
          position: relative;

          @media (max-width: 1124px) {
            padding-top: calc(700 / 728 * 100%);
          }
          @media (max-width: 992px) {
            height: 100%;

          }

          .content {
            position: absolute;
            z-index: 99;
            top: 70px;

            @media (max-width: 992px) {
              display: none;
            }

            p {
              font-family: 'Cammron';
              font-size: 40px;
              line-height: 48px;
              color: #E9E4DC;

            }
          }

        }
      }
    }
  }

  .slider_wrapper_right {
    height: 100%;

    .slider_wrapper_right__init {
      background: ${hover};
      padding: 70px 0 70px 70px;
      height: calc(100% - 20%);
      position: relative;
      @media (max-width: 992px) {
        height: auto;
        padding: 70px 30px;
      }
      @media (max-width: 767px) {
        padding-right: 30px;
      }
      .single_item_content {
        h3 {
          color: ${white};
          margin: 0 0 30px;
        }
        p {
          color: ${white};
        }
      }
    }
  }

  .top_text {
    p {
      font-family: 'Cammron Demo';
      font-size: 32px;
      line-height: 44px;
      color: #191818;
      margin-bottom: 60px;
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    padding: 0 70px;
    bottom: 40px;
    @media (max-width: 992px) {
      position: relative;
      margin-top: 30px;
      padding: 0;
      left: unset;
      right: unset;
      bottom: unset;
      flex-direction: row-reverse;
    }

    .count {
      @media (max-width: 992px) {
        padding-right: 15px;

      }

      p {
        color: rgba(247, 244, 244, 0.5);
        font-size: 16px;
        font-weight: 600;
        line-height: 28px;
      }

      .current {
        font-size: 32px;
        font-weight: 600;
        line-height: 44px;
        color: #F7F4F4;
        margin-right: 8px;
      }

      .total {
        color: rgba(247, 244, 244, 0.5);
        font-size: 16px;
        font-weight: 600;
        line-height: 28px;
      }


    }

    .slider_nav {
      display: flex;

      li:first-child {
        margin-right: 30px;
        @media (max-width: 992px) {
          margin-right: 15px;

        }
      }

      li {
        svg {
          cursor: pointer;
          @media (max-width: 992px) {
            height: 50px;
            width: 50px;
          }

          #Ellipse_16 {
            transition: 0.7s all ease;
          }

          &:hover {
            #Ellipse_16 {
              r: 35;
            }
          }
        }
      }
    }


    @media (max-width: 992px) {
      .slick-slider {
        margin: 0 0 -10px;
      }
    }
  }
  //navigation
  .navigation {
    // position: absolute;
    // right: ${props => props.offset ? props.offset : '90'}px;
    // top: calc(50% - 10vh);
    // transform: translateY(-50%);
    // display: inline-block;
    z-index: 1;
    

    @media(max-width: 767px){
      .col{
        padding-left: 0px !important;
        padding-right: 0px !important;
      }
    }

    ul {
      display: flex;
      flex-direction: row-reverse;

      li {
        cursor: pointer;

        &:first-child {
          margin-bottom: 20px;
          margin-right: 0;
          margin-left: 20px;
          svg{
            margin-right: 20px;
          }
        }

        svg {
          path, #Rectangle_5661 {
            //transition: strokeDasharray 0.3s ease-in-out;
            transition: all 1s cubic-bezier(.25, .74, .22, .99);
          }
        }


        &:hover {
          svg {
            #Rectangle_5661 {
              opacity: 1;

              stroke-dasharray: 140px;
            }

            path {
              stroke: ${hover};
            }
          }
        }
      }
    }
  }
`;


export default SliderCount;